import _styled4styled_components from 'styled-components';
            const _styled4 = typeof _styled4styled_components.default === 'undefined' ? _styled4styled_components : _styled4styled_components.default;;
import _styled3styled_components from 'styled-components';
            const _styled3 = typeof _styled3styled_components.default === 'undefined' ? _styled3styled_components : _styled3styled_components.default;;
import _styled2styled_components from 'styled-components';
            const _styled2 = typeof _styled2styled_components.default === 'undefined' ? _styled2styled_components : _styled2styled_components.default;;
import _styledstyled_components from 'styled-components';
            const _styled = typeof _styledstyled_components.default === 'undefined' ? _styledstyled_components : _styledstyled_components.default;;
import { css as _css } from "styled-components";
import React from 'react';
import Spinner from './components/Spinner';
import useMountedRef from './hooks/useMountedRef';
const iconStyles = [{
  "position": "absolute",
  "left": "0px",
  "top": "0px",
  "display": "inline-block",
  "--tw-translate-x": "-50%",
  "transform": "translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))",
  "--tw-translate-y": "-50%"
}];
export default function Photo({
  src,
  loaded,
  broken,
  className,
  onPhotoLoad,
  loadingElement,
  brokenElement,
  ...restProps
}) {
  const mountedRef = useMountedRef();
  function handleImageLoaded(e) {
    const {
      naturalWidth,
      naturalHeight
    } = e.target;
    if (mountedRef.current) {
      onPhotoLoad({
        loaded: true,
        naturalWidth,
        naturalHeight
      });
    }
  }
  function handleImageBroken() {
    if (mountedRef.current) {
      onPhotoLoad({
        broken: true
      });
    }
  }
  if (src && !broken) {
    return <>
        <_StyledImg className={className} src={src} onLoad={handleImageLoaded} onError={handleImageBroken} alt="" {...restProps} $_css2={[{
        "cursor": "grab",
        "--tw-bg-opacity": "1",
        "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
        ":active": {
          "cursor": "grabbing"
        }
      }, _css(["max-width:initial;"])]} />
        {!loaded && (<_StyledSpan>{loadingElement}</_StyledSpan> || <_StyledSpinner />)}
      </>;
  }
  if (brokenElement) {
    return <_StyledSpan2>
        {typeof brokenElement === 'function' ? brokenElement({
        src
      }) : brokenElement}
      </_StyledSpan2>;
  }
  return null;
}
var _StyledImg = _styled("img").withConfig({
  componentId: "sc-r1gl4k-0"
})(["", ""], p => p.$_css2);
var _StyledSpan = _styled("span").withConfig({
  componentId: "sc-r1gl4k-1"
})(["", ""], iconStyles);
var _StyledSpinner = _styled(Spinner).withConfig({
  componentId: "sc-r1gl4k-2"
})(["", ""], iconStyles);
var _StyledSpan2 = _styled("span").withConfig({
  componentId: "sc-r1gl4k-3"
})(["", ""], iconStyles);